import { toast } from "react-toastify";
import { PermissionActionTypes, PermissionActions } from "../../../actionTypes/permissions/permissionTypes";
import { call, delay, put, takeLatest } from "redux-saga/effects";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import {
  getPermissionsByUserId,
  setPermissionByUserId,
  setPermissionList,
  setPermissionListCount,
} from "../../../actions/permissions/permissionActions";
import {
  addPermissionApi,
  getPermissionByUserIdApi,
  getPermissionListApi,
  setPermissionsInUserApi,
} from "../../requests/permissions/permission";
import { setPostApiStatus } from "../../../actions/apiStatusActions";


function* getPermssionListHandler(action: PermissionActionTypes) {
  if (action.payload.search) {
    yield delay(500); //to hit search api after 500ms of the last key stroke
  }
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPermissionListApi, action.payload);
    if (data.status) {
      const dummyData = [
        {
          id: 1,
          name: "--",
          code: "--",
          description: "--",
        },
      ];
      yield put(setPermissionList(data?.data?.rows || dummyData));
      yield put(setPermissionListCount(Math.ceil(data?.data?.count / action.payload.pageLimit) || 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* addPermissionHandler(action: PermissionActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(addPermissionApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPermissionByUserIdHandler(action: PermissionActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPermissionByUserIdApi, action.payload);
    if (data.status) {
      const fallbackData = {
        id: 0,
        role_name: "--",
        sections: [
          {
            id: 1,
            name: "--",
            description: "--",
            permissions: [
              {
                id: 2,
                name: "--",
                code: "--",
                description: "--",
              },
            ],
          },
        ],
        assigned_permission: [],
      };
      yield put(setPermissionByUserId(data?.data ?? fallbackData));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* setPermissionsInUserHandler(action: PermissionActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(setPermissionsInUserApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(getPermissionsByUserId(action.payload.userId));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// Permission sagas
export default function* permissionSaga() {
  yield takeLatest(PermissionActions.GET_PERMISSION_LIST, getPermssionListHandler);
  yield takeLatest(PermissionActions.ADD_PERMISSION, addPermissionHandler);
  yield takeLatest(PermissionActions.GET_PERMISSION_BY_USERID, getPermissionByUserIdHandler);
  yield takeLatest(PermissionActions.SET_PERMISSION_IN_USER, setPermissionsInUserHandler);
}
